<la-dialog-header>
  <div class="header" header-title>
    <div class="icon-container">
      <mat-icon class="material-icons-outlined">diamond</mat-icon>
    </div>
    <p class="dialog-title">Upgrade to unlock more of Land App</p>
  </div>
</la-dialog-header>

<la-dialog-content>
  <section class="tier-card">
    <div class="tier-summary">
      <h3 class="tier-title">{{ config.title }}</h3>
      <p class="tier-description">{{ config.description }}</p>
      <p class="price-line">
        <span class="price">{{ config.pricePerUserMonthly }}</span>
        <span>{{ config.billingLabel }}</span>
      </p>
    </div>

    <ul class="feature-list">
      @for (feature of config.features; track feature) {
        <li>{{ feature }}</li>
      }
    </ul>
  </section>
</la-dialog-content>

<la-dialog-footer class="dialog-actions">
  @if (config.canUpgrade) {
    <ng-container la-dialog-footer-right>
      <la-button appearance="basic" matDialogClose>Maybe later</la-button>
      <la-button appearance="primary" (action)="onUpgrade()">Upgrade</la-button>
    </ng-container>
  } @else {
    <span la-dialog-footer-right class="ask-admin-label">Ask your admin to upgrade your subscription</span>
  }
</la-dialog-footer>
